import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { createCssCustomButton } from '../../helpers/createCssCustomButton'
import { createNavigationUrl } from '../../helpers/createNavigationUrl'
import Icon from '../Icon/Icon'
import './Button.scss'

const Button = ({
  icon,
  button,
  customButton,
  matchPages,
  classContainer,
  classButton
}) => {

  const ButtonIcon = () => icon ? <Icon style={{ marginRight: '.5em' }} {...icon} /> : null
  return (
    <>
      {button.url ? (
        <div className={`${classContainer || 'my-5 d-flex justify-content-center'} button-container`}>
          <a
            className={`${createCssCustomButton(customButton) +
              ' d-flex flex-row justify-content-center align-items-center ' +
              classButton || ''} anchor-container`}
            href={
              button.url.includes('https://')
                ? button.url
                : `https://${button.url}`
            }
            target="about_blank"
          >
            <ButtonIcon />
            {button.label ? button.label : 'VER MÁS' }
          </a>
        </div>
      ) : (
        <div className={`${classContainer || 'my-5 d-flex justify-content-center'} button-container`}>
          <Link
            className={`${createCssCustomButton(customButton) +
              ' d-flex flex-row justify-content-center align-items-center ' +
              classButton || ''} anchor-container`}
            to={createNavigationUrl(matchPages, button)}
          >
            <ButtonIcon />
            {button.label ? button.label : 'VER MÁS' }
          </Link>
        </div>
      )}
    </>
  )
}

export default Button

Button.propTypes = {
  icon: PropTypes.object,
  button: PropTypes.object.isRequired,
  customButton: PropTypes.object.isRequired,
  classContainer: PropTypes.string,
  matchPages: PropTypes.array.isRequired,
  classButton: PropTypes.string
}
